import React from 'react';

import Button from '../../common/Button/Button';
import randomHouse from '../../../assets/images/random_house.svg';

import cn from 'classnames';
import styles from './FormNotConnected.scss';

const FormNotConnected = ({ className, reconnectFormSending }) => {
  function handleButtonClick() {
    reconnectFormSending();
  }

  return (
    <div className={cn(styles.FormNotConnected, className)}>
      <div className={styles.Title}>
        NEDVEX
      </div>
      <div className={styles.Image}>
        <img alt="house" src={randomHouse} />
      </div>
      <div className={styles.Label}>
        Отсутствует подключение к интернету
      </div>
      <Button className={styles.Button} onClick={handleButtonClick}>Повторить попытку</Button>
    </div>
  );
};

export default FormNotConnected;



// WEBPACK FOOTER //
// ./src/components/Login/FormNotConnected/FormNotConnected.js